import { Window } from "@progress/kendo-react-dialogs";
import {
  fieldFocusIndex,
  isGalleryEditor,
  isStageEditor,
  isTableEditor,
  selectedFieldPropertyValues,
  selectedSectionName,
  selectedFieldName as selectedTemplateFieldName,
  templateData,
} from "../../Template/NewTemplateSignals";
import {
  editedPropertyValues,
  selectedFieldName,
  selectedGalleryFieldPropertyValues,
} from "../GalleryConstructor/GalleryConstructorSignals";
import { visibilityBuilderVisibility } from "../Store/CommonSignals";

import {
  editedPropertyValues as editedColumnPropertyValues,
  selectedColumnFieldPropertyValues,
  selectedColumnIndex,
} from "../../Fields/ColumnsConstructor/ColumnsConstructorSignals";
import VisibilityRuleBuilder from "./VisibilityRuleBuilder";

const getCurrentPropertyValues = () => {
  if (isGalleryEditor.value) {
    return {
      ...selectedGalleryFieldPropertyValues.value,
      ...editedPropertyValues.value?.[selectedFieldName.value],
    };
  }

  if (isStageEditor.value) {
    return {
      VisibilityRules: templateData.value?.properties?.VisibilityRules || [],
    };
  }

  if (isTableEditor.value) {
    return {
      ...selectedColumnFieldPropertyValues.value,
      ...editedColumnPropertyValues.value?.[selectedColumnIndex.value],
    };
  }

  return selectedFieldPropertyValues.value;
};

export const VisbilityBuilderWindow = () => {
  const currentPropertyValues = getCurrentPropertyValues();

  const handlePropertyChange = ({ propName, propValue }) => {
    if (isGalleryEditor.value) {
      editedPropertyValues.value = {
        ...editedPropertyValues.value,
        [selectedFieldName.value]: {
          ...editedPropertyValues.value[selectedFieldName.value],
          [propName]: propValue,
        },
      };
    } else if (isStageEditor.value) {
      templateData.value = {
        ...templateData.value,
        properties: {
          ...templateData.value.properties,
          [propName]: propValue,
        },
      };
    } else if (isTableEditor.value) {
      editedColumnPropertyValues.value = {
        ...editedColumnPropertyValues.value,
        [selectedColumnIndex.value]: {
          ...editedColumnPropertyValues.value[selectedColumnIndex.value],
          [propName]: propValue,
        },
      };
    } else if (fieldFocusIndex.value === null) {
      templateData.value = {
        ...templateData.value,
        sections: templateData.value.sections.map((section) => {
          if (section.sectionName === selectedSectionName.value) {
            return {
              ...section,
              properties: {
                ...section.properties,
                [propName]: propValue,
              },
            };
          }
          return section;
        }),
      };
    } else {
      templateData.value = {
        ...templateData.value,
        sections: templateData.value.sections.map((section) => {
          if (section.sectionName === selectedSectionName.value) {
            return {
              ...section,
              fields: section.fields.map((field) => {
                if (field.fieldName === selectedTemplateFieldName.value) {
                  return {
                    ...field,
                    properties: {
                      ...field.properties,
                      [propName]: propValue,
                    },
                  };
                }
                return field;
              }),
            };
          }
          return section;
        }),
      };
    }
  };

  return (
    <>
      {visibilityBuilderVisibility.value && (
        <Window
          onClose={() => {
            visibilityBuilderVisibility.value = false;
            isStageEditor.value = false;
          }}
          className="condition-builder-window"
          initialHeight={500}
          initialWidth={800}
          title={"Visibility Rules Manager"}
        >
          <VisibilityRuleBuilder
            handlePropertyChange={handlePropertyChange}
            currentPropertyValues={currentPropertyValues}
            onClose={() => {
              visibilityBuilderVisibility.value = false;
              isStageEditor.value = false;
            }}
          />
        </Window>
      )}
    </>
  );
};
